import { render, staticRenderFns } from "./codeToOpenid.vue?vue&type=template&id=708c3e1e&scoped=true&"
import script from "./codeToOpenid.vue?vue&type=script&lang=js&"
export * from "./codeToOpenid.vue?vue&type=script&lang=js&"
import style0 from "./codeToOpenid.vue?vue&type=style&index=0&id=708c3e1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c3e1e",
  null
  
)

export default component.exports